<ng-container *transloco="let t">
  <div
    [class.form-legend]="type === 'form'"
    [class.table-legend]="type === 'table'"
    [class.grid-container-legend]="type === 'grid'"
    [class.grid-sidebar-collapsed]="type === 'grid' && (gridService.sidebar$ | async) === 'collapsed'"
    [ngStyle]="style"
  >
    <h5 *ngIf="showHeader">{{ t(headerTextKey) }}</h5>
    <div class="entries">
      <ng-container *ngIf="showHeaderInline">{{ t(headerTextKey) }}</ng-container>
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
